import adresseGenerer from '@/services/general/genererAdresse';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import { COULEUR_PUCE_DEFAULT } from '@/configuration/general/carteConf';
import entiteCommercialeGenerer from '@/services/entiteCommerciale/genererEntiteCommerciale';
import { SENS_VENTE } from '@/configuration/devisConf';
import getSupportCommercial from './getSupportCommercial';

export default async function genererProduitReseau() {
  const supportCommerical = await getSupportCommercial(CATEGORIE_REGROUPEMENT);
  const adresse = adresseGenerer();
  return {
    reference: null,
    libelle: null,
    liaisonsTarif: [],
    supportCommercialId: supportCommerical.id,
    supportCommercial: supportCommerical,
    entiteCommerciale: entiteCommercialeGenerer(),
    schemaComptableId: null,
    schemaComptable: null,
    secteurs: [],
    produitReseau: {
      affectationsReseauFace: [],
      formatId: null,
      typeReseauId: null,
      categorie: null,
      dateDebut: null,
      dateFin: null,
      adresse: adresse,
      produitParDefautId: null,
      affimetrie: {},
      formatsAffiche: [],
    },
    tiersId: null,
    logisticable: true,
    couleurArgb: null,
    couleurHtmlRgb: COULEUR_PUCE_DEFAULT,
    couleurHtmlRgba: COULEUR_PUCE_DEFAULT,
    compteAnalytiqueId: null,
    agenceId: null,
    controleDisponibilite: true,
    categorieGroupeProduitDeductibleId: null,
    sens: SENS_VENTE,
    produitsConcessionnaire: [],
    categorieOperation: null,
    commissionsVendeur: [],
    objectifsVente: [],
    reglesAchat: [],
    cgvs: [],
    demandeInterventionTypes: [],
    regleFacturationId: null,
    assistantId: null,
    commentaireVente: null,
    renouvelable: true,
  };
}
